/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class UserService {
    public static $inject = [
        '$resource',
        '$q',
    ];

    public currentUser: ICurrentUser = {
        isAuth: false,
        permissions: [],
        userData: {},
        isSuperUserMask: false,
        isSuperUser: true,
        isInsuranceOnlyClient: false,
        isHRM: false,
    };

    constructor($resource: ng.resource.IResourceService,
                private $q: ng.IQService) {
        this.userRes = $resource('/api/me');
        this.initd = $q.defer();
    }

    private initd;

    public loadUser = () => {
        let promise: angular.IPromise<any> = this.userRes.get().$promise;

        promise.then((response: any) => {
            var userData = response;
            this.currentUser.userData = response;
            this.currentUser.isAuth = true;
            this.currentUser.isSuperUserMask = response.superuser_mask;
            this.currentUser.isSuperUser = response.user.is_superuser;
            this.currentUser.permissions = response.user.get_all_permissions;
            this.currentUser.isInsuranceOnlyClient = response.is_insurance_only_client;
            if (userData && userData.user) {
                this.currentUser.isHRM = userData.user.clearance == 'admin';
            }

            //create userId attr in order to track in analytics
            angular.element('body').attr('user-id', this.currentUser.userData.id);

            this.initd.resolve();
        }, (response: any) => {
            this.currentUser.isAuth = !(response.status === 403);
            this.initd.reject();
        });

        return promise;
    };

    public getCurrentUser = () => {
        return this.currentUser;
    };

    public isAuth = () => {
        return this.currentUser.isAuth;
    };

    public clearUser = () => {
        this.currentUser.isAuth = false;
        this.currentUser.userData = {};
    };

    public getLoadingPromise = () => {
        return this.initd.promise;
    };

    public hasPermission = (permission: string) => {
        return (this.currentUser.permissions.indexOf(permission) !== -1);
    };

    public getUserId = () => {
        return this.currentUser.userData.id;
    };

    public getSuperiorId = () => {
        let superiorsLength: number = this.currentUser.userData.all_superiors.length;
        if (superiorsLength > 0) {
            return this.currentUser.userData.all_superiors[superiorsLength - 1].id;
        } else {
            return this.getCurrentUser();
        }

    };

    private userRes;
}

angular.module('beneple.global')
    .service('User', UserService);



// WEBPACK FOOTER //
// ./frontend/scripts/global/services/user.service.ts